import { useEffect } from "react";
import { revokeAuthData } from "features/auth/helpers";

export default function useLogin() {
    useEffect(revokeAuthData, []);
};
